export function uploadTake({ file, title, durationMs, csrf, onProgress }) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open("POST", "/recordings")
    xhr.setRequestHeader("X-CSRF-Token", csrf)
    xhr.setRequestHeader("Accept", "application/json")
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) onProgress(event.loaded / event.total)
    }
    xhr.onload = () => {
      let data = {}
      try {
        data = JSON.parse(xhr.responseText || "{}")
      } catch {
        data = {}
      }
      if (xhr.status >= 200 && xhr.status < 300) resolve(data)
      else reject(new Error(data.error || "The upload did not go through."))
    }
    xhr.onerror = () => reject(new Error("The network dropped the upload. It will try again when you reopen this page."))
    const body = new FormData()
    body.append("file", file, "recording.webm")
    body.append("title", title || "")
    body.append("duration_ms", durationMs ? String(durationMs) : "")
    xhr.send(body)
  })
}

export async function fetchStatus(publicId) {
  const response = await fetch(`/recordings/${publicId}/status`, {
    headers: { Accept: "application/json" }
  })
  if (!response.ok) throw new Error("Could not check the recording.")
  return response.json()
}
